import React, { useEffect, useState } from "react";
import "./index.scss";

import useDeviceDetect from "../../hook/useDeviceDetect";
import { useTheme } from "../../hook/useThemes";
import Mobile from "./components/Mobile";
import Desktop from "./components/Desktop";
import image1 from "../../assets/images/card_1_htp.png";
import image2 from "../../assets/images/card_2_htp.png";
import image3 from "../../assets/images/card_3_htp.png";
import Logo from "../../assets/images/logo-upordown_demo.png";
import iconClose from "../../assets/images/icon-close-how-to-play.svg";

export default function HowToPlay() {
  const { isMobile, isTablet } = useDeviceDetect();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { lang } = useTheme();
  useEffect(() => {
    setOpenModal(false);
  }, [isMobile]);

  return (
    <>
      {isTablet && (
        <Mobile lang={lang} openModal={openModal} setOpenModal={setOpenModal} />
      )}

      {!isTablet && (
        <Desktop openModal={openModal} setOpenModal={setOpenModal} />
      )}

      <div className="wrap-icon-preload">
        <img src={image1} alt="img" className="image-h_t_play" />
        <img src={image2} alt="img" className="image-h_t_play" />
        <img src={image3} alt="img" className="image-h_t_play" />
        <img src={Logo} alt="logo" className="logo-how-to-play" />
        <img src={iconClose} alt="icon_close" />
      </div>
    </>
  );
}
